document.addEventListener("DOMContentLoaded", () => {
  // 1. DYNAMIC PRICE & BUNDLE SWITCHER
  const bundleInputs = document.querySelectorAll('input[name="bundle"]');
  const priceNow = document.getElementById("priceNow");
  const priceWas = document.getElementById("priceWas");
  const priceSave = document.getElementById("priceSave");
  const atcBtn = document.getElementById("atcBtn");
  const stickyPrice = document.getElementById("stickyPrice");
  const cartTotal = document.getElementById("cartTotal");

  function updatePrices(selectedInput) {
    const price = selectedInput.getAttribute("data-price");
    const was = selectedInput.getAttribute("data-was");

    const pNum = parseFloat(price);
    const wNum = parseFloat(was);
    const savePercent = Math.round((1 - pNum / wNum) * 100);

    if (priceNow) priceNow.textContent = `$${price}`;
    if (priceWas) priceWas.textContent = `$${was}`;
    if (priceSave) priceSave.textContent = `Save ${savePercent}%`;
    if (atcBtn) atcBtn.textContent = `ADD TO CART — $${price}`;
    if (stickyPrice) stickyPrice.textContent = `$${price}`;
    if (cartTotal) cartTotal.textContent = `$${price}`;

    document.querySelectorAll(".bundle").forEach((card) => card.classList.remove("is-selected"));
    const parentCard = selectedInput.closest(".bundle");
    if (parentCard) parentCard.classList.add("is-selected");
  }

  bundleInputs.forEach((input) => {
    input.addEventListener("change", (e) => updatePrices(e.target));
  });

  const activeBundle = document.querySelector('input[name="bundle"]:checked');
  if (activeBundle) updatePrices(activeBundle);

  // 2. GALLERY THUMBNAILS + ARROWS (fade) + VIDEO
  const thumbs = Array.from(document.querySelectorAll(".thumb"));
  const mainImg = document.getElementById("mainImg");
  const galleryVideo = document.getElementById("galleryVideo");
  const galleryMain = document.querySelector(".gallery-main");
  const galleryPrev = document.getElementById("galleryPrev");
  const galleryNext = document.getElementById("galleryNext");

  function pauseGalleryVideo() {
    if (!galleryVideo) return;
    galleryVideo.pause();
    galleryVideo.hidden = true;
    galleryMain?.classList.remove("is-video");
  }

  function showGalleryIndex(index) {
    if (!thumbs.length) return;
    const i = ((index % thumbs.length) + thumbs.length) % thumbs.length;
    const thumb = thumbs[i];
    const type = thumb.getAttribute("data-type") || "image";
    const newSrc = thumb.getAttribute("data-src");
    if (!newSrc) return;

    thumbs.forEach((t) => t.classList.remove("is-active"));
    thumb.classList.add("is-active");

    if (type === "video") {
      if (mainImg) mainImg.classList.add("is-fading");
      if (galleryVideo) {
        const poster = thumb.getAttribute("data-poster");
        if (poster) galleryVideo.setAttribute("poster", poster);
        const source = galleryVideo.querySelector("source");
        if (source && source.getAttribute("src") !== newSrc) {
          source.setAttribute("src", newSrc);
          galleryVideo.load();
        }
        galleryVideo.hidden = false;
        galleryMain?.classList.add("is-video");
        galleryVideo.play().catch(() => {});
      }
      window.setTimeout(() => {
        if (mainImg) mainImg.classList.remove("is-fading");
      }, 180);
      return;
    }

    pauseGalleryVideo();
    if (!mainImg) return;
    if (mainImg.getAttribute("src") === newSrc) return;
    mainImg.classList.add("is-fading");
    window.setTimeout(() => {
      mainImg.src = newSrc;
      mainImg.alt = thumb.querySelector("img")?.alt || mainImg.alt;
      mainImg.classList.remove("is-fading");
    }, 180);
  }

  function currentGalleryIndex() {
    const active = thumbs.findIndex((t) => t.classList.contains("is-active"));
    return active >= 0 ? active : 0;
  }

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener("click", () => showGalleryIndex(index));
  });

  if (galleryPrev) {
    galleryPrev.addEventListener("click", () => showGalleryIndex(currentGalleryIndex() - 1));
  }
  if (galleryNext) {
    galleryNext.addEventListener("click", () => showGalleryIndex(currentGalleryIndex() + 1));
  }

  // 3. COUNTDOWN TIMER
  const timerEl = document.getElementById("timer");
  if (timerEl) {
    let duration = 2 * 3600 + 59 * 60 + 47;
    setInterval(() => {
      duration -= 1;
      if (duration < 0) duration = 3600 * 3;
      const h = String(Math.floor(duration / 3600)).padStart(2, "0");
      const m = String(Math.floor((duration % 3600) / 60)).padStart(2, "0");
      const s = String(Math.floor(duration % 60)).padStart(2, "0");
      timerEl.textContent = `${h}:${m}:${s}`;
    }, 1000);
  }

  // 4. SCROLL REVEAL
  const reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add("is-visible"));
  }

  // 6. CART DRAWER + SHOPIFY CHECKOUT
  const cartDrawer = document.getElementById("cartDrawer");
  const drawerBackdrop = document.getElementById("drawerBackdrop");
  const drawerClose = document.getElementById("drawerClose");
  const cartLines = document.getElementById("cartLines");
  const stickyBtn = document.getElementById("stickyBtn");
  const checkoutBtn = document.getElementById("checkoutBtn");

  function getCartConfig() {
    const el = document.getElementById("cleanify-cart-config");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (_) {
      return null;
    }
  }

  function selectedBundleInput() {
    return document.querySelector('input[name="bundle"]:checked');
  }

  function resolveVariantId(config, bundleInput) {
    if (!config || !bundleInput) return null;
    const key = bundleInput.getAttribute("data-variant-key") || bundleInput.value;
    const mapped = config.variants && config.variants[key];
    if (mapped) return mapped;
    if (key === "1" && config.fallbackVariantId) return config.fallbackVariantId;
    return null;
  }

  function setBusy(isBusy, label) {
    [atcBtn, stickyBtn, checkoutBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !!isBusy;
    });
    if (atcBtn && label) atcBtn.textContent = label;
  }

  async function addToShopifyCart(variantId, label, price) {
    const clearRes = await fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } });
    if (!clearRes.ok && clearRes.status !== 200) {
      // ignore clear failures; continue to add
    }
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: { Bundle: label },
          },
        ],
      }),
    });
    const raw = await res.text();
    let data = null;
    try {
      data = JSON.parse(raw);
    } catch (_) {
      throw new Error(
        res.status === 429
          ? "Shopify temporarily blocked the request. Refresh and try again."
          : "Could not add to cart (unexpected response)."
      );
    }
    if (!res.ok) {
      throw new Error((data && (data.description || data.message)) || "Could not add to cart");
    }
    return data;
  }

  function renderCartLine(label, price, imageUrl) {
    if (!cartLines) return;
    const img = imageUrl || "assets/hero-plate.jpg";
    cartLines.innerHTML = `
      <div class="cart-line">
        <img src="${img}" width="60" alt="Cleanify Pro" />
        <div>
          <strong>${label}</strong>
          <p>Quantity: 1 · FREE Shipping</p>
          <span class="cart-line-price">$${price}</span>
        </div>
      </div>
    `;
    if (cartTotal) cartTotal.textContent = `$${price}`;
  }

  async function openCart() {
    const selectedBundle = selectedBundleInput();
    const price = selectedBundle ? selectedBundle.getAttribute("data-price") : "74.99";
    const label = selectedBundle ? selectedBundle.getAttribute("data-label") : "2× Cleanify Pro Set";
    const config = getCartConfig();
    const onShopify = !!(config && config.enabled);

    if (onShopify) {
      const variantId = resolveVariantId(config, selectedBundle);
      if (!variantId) {
        alert(
          "Bundle variants are not set yet.\n\nIn Shopify Admin → Products → Cleanify → Variants, create:\n1× Starter Kit ($44.99)\n2× Pro Set ($74.99)\n3× Family Pack ($99.99)\n\nThen refresh this page."
        );
        return;
      }
      try {
        setBusy(true, "ADDING…");
        await addToShopifyCart(variantId, label, price);
        renderCartLine(label, price, config.image);
        setBusy(false, `ADD TO CART — $${price}`);
      } catch (err) {
        console.error(err);
        setBusy(false, `ADD TO CART — $${price}`);
        alert("Could not add to cart. Check the product is Active and variants exist.");
        return;
      }
    } else {
      renderCartLine(label, price);
    }

    if (cartDrawer && drawerBackdrop) {
      cartDrawer.classList.add("is-open");
      cartDrawer.setAttribute("aria-hidden", "false");
      drawerBackdrop.hidden = false;
      document.body.classList.add("drawer-open");
    }
  }

  function closeCart() {
    if (cartDrawer && drawerBackdrop) {
      cartDrawer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
      drawerBackdrop.hidden = true;
      document.body.classList.remove("drawer-open");
    }
  }

  if (atcBtn) atcBtn.addEventListener("click", openCart);
  if (stickyBtn) stickyBtn.addEventListener("click", openCart);
  if (drawerClose) drawerClose.addEventListener("click", closeCart);
  if (drawerBackdrop) drawerBackdrop.addEventListener("click", closeCart);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCart();
  });

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", () => {
      const config = getCartConfig();
      if (config && config.enabled) {
        window.location.href = "/checkout";
        return;
      }
      checkoutBtn.textContent = "Connect Shopify product to enable checkout";
      setTimeout(() => {
        checkoutBtn.textContent = "PROCEED TO CHECKOUT";
      }, 2200);
    });
  }

  // Sticky hide when buybox visible (mobile)
  const buy = document.getElementById("buy");
  const sticky = document.getElementById("stickyAtc");
  if (buy && sticky && "IntersectionObserver" in window) {
    const stickyIo = new IntersectionObserver(
      ([entry]) => {
        const mobile = window.matchMedia("(max-width: 899px)").matches;
        if (!mobile) return;
        const hide = entry.isIntersecting && entry.intersectionRatio > 0.35;
        sticky.style.opacity = hide ? "0" : "1";
        sticky.style.pointerEvents = hide ? "none" : "auto";
      },
      { threshold: [0, 0.35, 0.6] }
    );
    stickyIo.observe(buy);
  }

  // Pause proof video when off-screen (saves CPU / avoids jank)
  const proofVideo = document.getElementById("proofVideo");
  if (proofVideo && "IntersectionObserver" in window) {
    const vio = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting && !proofVideo.paused) {
          proofVideo.pause();
        }
      },
      { threshold: 0.15 }
    );
    vio.observe(proofVideo);
  }

  const y = document.getElementById("y");
  if (y) y.textContent = String(new Date().getFullYear());

  // Reviews carousel
  const track = document.getElementById("reviewTrack");
  const revPrev = document.getElementById("revPrev");
  const revNext = document.getElementById("revNext");
  const revDots = document.getElementById("revDots");

  if (track) {
    const cards = [...track.querySelectorAll(".review")];
    const scrollByCard = (dir) => {
      const card = cards[0];
      if (!card) return;
      const step = card.getBoundingClientRect().width + 14;
      track.scrollBy({ left: dir * step, behavior: "smooth" });
    };

    revPrev?.addEventListener("click", () => scrollByCard(-1));
    revNext?.addEventListener("click", () => scrollByCard(1));

    if (revDots && cards.length) {
      cards.forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.setAttribute("aria-label", `Go to review ${i + 1}`);
        dot.addEventListener("click", () => {
          cards[i].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
        });
        revDots.appendChild(dot);
      });

      const syncDots = () => {
        const left = track.scrollLeft;
        const width = cards[0].getBoundingClientRect().width + 14;
        const idx = Math.round(left / width);
        [...revDots.children].forEach((d, i) => d.classList.toggle("is-active", i === idx));
      };
      track.addEventListener("scroll", () => requestAnimationFrame(syncDots), { passive: true });
      syncDots();
    }
  }
});
